<!--
 * @Description: 置为无效线索
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-12-27 10:39:55
 * @LastEditors: mdb
-->
<template>
  <cos-modal
    v-model:visible="visible"
    title="置为无效"
    class="clueMerge"
    width="670px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible">
      <a-form-item name="clueIdList" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
        <a-select v-model:value="editForm.clueIdList" mode="tags" placeholder="请选择" :disabled="true">
          <a-select-option v-for="item in data" :key="item.clueId" :value="item.clueId">{{
            item.customerName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        name="invalidId"
        label="无效原因"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <ParamCodesSelect v-model:value="editForm.invalidId" :options="paramCodeData.zbu_invalid_reason_lbu" allowClear />
      </a-form-item>
      <a-form-item name="remark" label="备注">
        <CosTextarea v-model:value="editForm.remark" :maxlength="2000" placeholder="请输入" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts" setup>
import { ref, onBeforeMount } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { clueToInvalid } from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import type { ClueManage } from '@/typings/api/marketingManage'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
defineProps({
  title: {
    type: String
  }
})

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  zbu_invalid_reason_lbu: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_invalid_reason_lbu']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const data = ref<ClueManage[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    clueToInvalid(editForm.value)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('置为无效线索成功')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: ClueManage[]) => {
  // 验证数量
  if (!rows || rows.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 校验状态
  const errorRow = rows.find((item) => item.clueStatus !== 0 || item.clueType === 3)
  if (errorRow) {
    DcMessage.error('请选择未投放的有效线索！')
    return
  }
  data.value = rows
  editForm.value = {
    clueIdList: rows.map((item) => item.clueId)
  }
  visible.value = true
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'invalidModel' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
</style>
